import React, { createContext, useContext } from 'react';

const AdminContext = createContext();

export function AdminProvider({ children, addManualToMasterDatabase }) {
  return (
    <AdminContext.Provider value={{ addManualToMasterDatabase }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    // Return null functions if not in admin context
    return { addManualToMasterDatabase: null };
  }
  return context;
}; 